import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { PurchasedItemsConfigDataState } from "@theStellarBlueprint/Store/Data/PurchasedItemsConfig/LoadPurchasedItemsConfigState";
import { Draft } from "immer";

const initialLoadPurchasedItemsState: PurchasedItemsConfigDataState = {
    page: "",
    Search: "",
    Description: "",
    pageSize: "",
    fromDate:"",
    toDate:""
};

const reducer = {
    "Custom/PurchasedItemsConfig/PopulatePurchasedItemsConfigParam": (draft: Draft<PurchasedItemsConfigDataState>) => { },
    "Custom/PurchasedItemsConfig/CleanPurchasedItemsConfig": (draft: Draft<PurchasedItemsConfigDataState>) => {
        draft.page = "";
        draft.Search = "";
        draft.Description = "";
        draft.pageSize = "";
        draft.fromDate = "";
        draft.toDate = "";
    },

    "Custom/PurchasedItemsConfig/SetPurchasedItemsConfig": (
        draft: Draft<PurchasedItemsConfigDataState>,
        action: { result: PurchasedItemsConfigDataState },
    ) => {
        draft.page = action.result.page || "";
        draft.Search = action.result.Search || "";
        draft.Description = action.result.Description || "";
        draft.pageSize = action.result.pageSize || "";
        draft.fromDate = action.result.fromDate || "";
        draft.toDate = action.result.toDate || "";
    },
};

export default createTypedReducerWithImmer(initialLoadPurchasedItemsState, reducer);
